import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const StatisticsSettings = () => {
  return (
    <SettingsCard title="Estadísticas">
      <Typography color="text.secondary">
        Sección en desarrollo
      </Typography>
    </SettingsCard>
  );
};

export default StatisticsSettings;